/**
 * Created by akrio on 2018/3/23.
 */
import { PAYMENT_INFO } from "../mutation-types";

export default {
  state: {
    paymentInfo: null, // 支付之前订阅类型
  },
  mutations: {
    [PAYMENT_INFO](state, info) {
      state.paymentInfo = info;
    },
  },
  getters: {
    [PAYMENT_INFO](state) {
      return state.paymentInfo;
    },
  },
};
